import ApiService from './api';

class ReportService {
  async scheduleReport(payload) {
    const token = localStorage.getItem('token');
    if (!token) throw new Error('No auth token found');

    return await ApiService.post('/reports/schedulers', payload, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
  }
  async getScheduledReports() {
    const token = localStorage.getItem('token');
    if (!token) throw new Error('No auth token found');

    return await ApiService.get('/reports/schedulers', {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
  }
}
export default new ReportService();
